<div class="top">
  @if (pricing.child) {
  <div class="wrapper">
    <fa-icon class="c-primary t-tiny" [icon]="faCheck"></fa-icon>
    <p>
      <span class="c-soft m-r-16" i18n>Children:</span>
      <strong class="t-large">{{
        pricing.child | unCurrency : tour.currency : tour.currency
      }}</strong>
      <span class="t-small c-soft" i18n>per person</span>
    </p>
  </div>
  } @if (pricing.infant) {

  <div class="wrapper">
    <fa-icon class="c-primary t-tiny" [icon]="faCheck"></fa-icon>
    <p>
      <span class="c-soft m-r-16" i18n>Infants:</span>
      <strong class="t-large">{{
        pricing.infant | unCurrency : tour.currency : tour.currency
      }}</strong>
      <span class="t-small c-soft" i18n>per person</span>
    </p>
  </div>
  }
</div>

<div class="top">
  @if (pricing.adult) {
  <div class="wrapper">
    <fa-icon class="c-primary t-tiny" [icon]="faCheck"></fa-icon>
    <p>
      <span class="c-soft m-r-16" i18n>Adults:</span>
      <strong class="t-large">{{
        pricing.adult | unCurrency : tour.currency : tour.currency
      }}</strong>
      <span class="t-small c-soft" i18n>per person</span>
    </p>
  </div>
  }
</div>
